function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { AxiosHeaders } from 'axios';
import { HttpClient } from 'api/http-client';
import { TeamsAPI } from 'api/teams';
import { isLinkMagicToken } from 'utils/token';
class RoleClient extends HttpClient {
    create(payload) {
        return this.post('/roles', payload);
    }
    update(roleId, payload) {
        return this.put(`/roles/${roleId}`, payload);
    }
    deleteRole(roleId) {
        return this.delete(`/roles/${roleId}`);
    }
    async createWithDefaultPlaceholder(payload) {
        const role = await this.post('/roles', payload);
        await TeamsAPI.createTeam({
            teamName: role.roleName,
            roleId: role.roleId
        });
        return role;
    }
    findAll() {
        return this.get('/roles');
    }
    findAllWithToken(token) {
        // LINK_MAGIC → X-Magic-Token header (query param crashes the legacy JWebToken parser);
        // legacy HS256 → ?token= query.
        if (isLinkMagicToken(token)) {
            return this.get('/roles', {
                headers: new AxiosHeaders({
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    'X-Magic-Token': token
                })
            });
        }
        return this.get(`/roles?token=${token}`);
    }
    constructor(...args){
        super(...args), _define_property(this, "makeRolesAvailableForPartner", (roleIds)=>this.put('/roles/bulk', roleIds.map((id)=>({
                    roleId: id
                }))));
    }
}
export const RolesApi = new RoleClient();
